import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Utilitarian Labs</title>
        <meta name="robots" content="noindex, follow" />
        <meta
          name="description"
          content="The page you are looking for does not exist."
        />
      </Helmet>

      <div style={{ textAlign: "center", padding: "120px 20px" }}>
        <h1 style={{ fontSize: "80px", margin: 0 }}>404</h1>
        <h2>Page Not Found</h2>
        <p>
          The page you are looking for may have been removed or the URL is incorrect.
        </p>

        <Link
          to="/"
          style={{
            display: "inline-block",
            marginTop: "20px",
            padding: "12px 24px",
            background: "#000",
            color: "#fff",
            textDecoration: "none",
            borderRadius: "6px"
          }}
        >
          Back to Home
        </Link>
      </div>
    </>
  );
};

export default NotFound;
